"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateCssVariables = generateCssVariables;
const prefix = 'hz';
function generateCssVariables(componentName, properties) {
  const variables = {};
  for (const property of properties) {
    const variableName = `--${prefix}-${componentName}-${property}`;
    variables[property] = variableName;
  }
  return variables;
}